export const routeName = 'contact';
export const slugs: Record<string, string> = {
	en: 'contact',
	es: 'contacto',
	ca: 'contacte',
	it: 'contatto',
};
export const sitemap = { changefreq: 'monthly', priority: '0.7', lastmod: '2025-01-01' };
